import { combineReducers } from 'redux';

import * as actionTypes from 'modules/audits/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import data from './data';
import type { AuditStartDateByAuditId } from './data';

export type AuditsUIDetailsStartDateReducer = {
  data: AuditStartDateByAuditId;
  loading: boolean;
};

export default combineReducers({
  data,
  loading: loading(actionTypes.PATCH_START_DATE_REQUEST),
});
